module.exports = __webpack_public_path__ + "img/1506017781.8984df08.jpg";